import Home from './pages/Home';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import PostDetail from './pages/PostDetail';
import Profile from './pages/Profile';
import { GeneralProvider } from './context/general/generalContext';
import Notification from './pages/Notification';
// import {token} from './utils/Auth'
// import { useEffect } from 'react';
import Cookies from 'universal-cookie';
 const cookies = new Cookies();
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PageError from './pages/PageError';

function App() {
   const tokenCookie = cookies.get('token');

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (!tokenCookie) {
  //       //cookies.set('token', token);
  //       <Link to="/unauthorized" />;
  //     }
  //   }, 50);
  // }, []);

  return (
    <BrowserRouter>
      <GeneralProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={!tokenCookie ?  <Navigate to="/unauthorized" /> : <Home />} />
            <Route path="/detail/:id" element={<PostDetail />} />
            <Route path="/notifications" element={<Notification />} />
            <Route path="/my-profile" element={<Profile />} />
            <Route path="/:errortype" element={<PageError />} />
          </Route>
        </Routes>
      </GeneralProvider>
      <ToastContainer position="bottom-right" autoClose={5000} />
    </BrowserRouter>
  );
}

export default App;
